<div class="global-search">
  <input
    type="text"
    aria-labelledby="Search Track"
    class="bm--common-search-field bm--common-search-field--main-bg"
    placeholder="What track are you looking for?"
    (input)="changeSearchValue($event)"
    (keyup.enter)="findTrackHandler()"
  />
  <div class="global-search__btn">
    <bmcore-button title="Search" styleName="center" (clickHandler)="findTrackHandler()"> </bmcore-button>
  </div>
</div>
